import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { RiskAssessmentCard } from '~/components/RiskAssessmentCard';
import { useShippingClaim } from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export function ShippingClaimRiskAssessment() {
  const claim = useShippingClaim();
  const storeId = useStoreId();

  const { data: riskAssessment, isPending } = useQuery({
    queryKey: ['shipping-claim-risk', storeId, `${claim.id}`],
    queryFn: () =>
      api.store(storeId).shippingProtection.claim(`${claim.id}`).risk(),
  });

  return (
    <RiskAssessmentCard riskAssessment={riskAssessment} isPending={isPending} />
  );
}
